import type { Control } from "react-hook-form";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type {
	BuildingFormInput,
	BuildingFormOutput,
} from "web_myplann/Portfolio/Forms/BuildingShared/buildingFormSchema";
import { FlatRowFormDatePicker } from "web_myplann/Shared/Components/FlatRow/FlatRowFormDatePicker";
import { FlatRowFormInput } from "web_myplann/Shared/Components/FlatRow/FlatRowFormInput";
import { DateView } from "web_myplann/Shared/Types/DateView";
import { DateFormat } from "web_myplann/Shared/Utils/dateFormats";
import { UNITS } from "web_myplann/Shared/Utils/units";

type Props = {
	control: Control<BuildingFormInput, unknown, BuildingFormOutput>;
};

const PropertyResources = Resources.PortfolioDetail.Property;
const FormResources = Resources.Portfolio.AddRealEstate;

export const BuildingAreaAndDateFields = ({ control }: Props) => {
	const { t } = useResource();

	return (
		<>
			<FlatRowFormInput
				control={control}
				name="usableArea"
				type="number"
				label={t(PropertyResources.UsableArea)}
				placeholder={t(FormResources.Placeholders.fill)}
				suffix={UNITS.squareMeter}
			/>
			<FlatRowFormDatePicker
				control={control}
				name="purchaseDate"
				label={t(PropertyResources.PurchaseDate)}
				views={[DateView.Year, DateView.Month, DateView.Day]}
				displayFormat={DateFormat.Display}
				placeholder={t(FormResources.Placeholders.select)}
			/>
		</>
	);
};
